import { GlobalHotKeys } from 'react-hotkeys'

// Hooks
import { useActions } from 'modules/audio/hooks'

// Utils
import mapValues from 'keymap'

const KeyboardShortCuts = () => {
  const { handleSkip, handleSeek, handleOffset, handleLoopToggle, handleAddToCollection, handleTogglePause, handleAddToFavorites } =
    useActions()

  const handlers = {
    NEXT: (e: KeyboardEvent | undefined) => handleSkip(e, false),
    PREV: (e: KeyboardEvent | undefined) => handleSkip(e, true),
    PLAYPAUSE: (e: KeyboardEvent | undefined) => handleTogglePause(e),
    SEEKFORWARD: () => handleSeek(1),
    SEEKBACKWARD: () => handleSeek(-1),
    SEEKFORWARDLONG: () => handleSeek(10),
    SEEKBACKWARDLONG: () => handleSeek(-10),
    OFFSETBEATFORWARD: () => handleOffset(1),
    OFFSETBEATBACKWARD: () => handleOffset(-1),
    ADDTOCOLLECTION: (e: KeyboardEvent | undefined) => {
      if (e?.metaKey) {
        return false
      }
      return handleAddToCollection()
    },
    ADDTOFAVORITES: (e: KeyboardEvent | undefined) => {
      if (e?.metaKey) {
        return false
      }
      return handleAddToFavorites()
    },
    TOGGLELOOP: (e: KeyboardEvent | undefined) => {
      if (e?.metaKey) {
        return false
      }
      return handleLoopToggle()
    },
  }

  return <GlobalHotKeys keyMap={mapValues} handlers={handlers} />
}

export default KeyboardShortCuts
